$(() => {
  let formLogin = $('#form-login');

  //  let isValid = formLogin.valid();


  formLogin.submit((e)=> {
    // e.preventDefault();
    formLogin.valid();
  })

})
